import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { SplitLayout } from '../layouts/SplitLayout';

export type DocumentTemplateProps = {
  /** Breadcrumbs above the title. */
  breadcrumbs?: ReactNode;
  eyebrow?: ReactNode;
  title: ReactNode;
  /** "Updated 11 Oct 2026". */
  updated?: ReactNode;
  /** The legal entity responsible. */
  entity?: ReactNode;
  /** A TableOfContents. */
  toc?: ReactNode;
  /** The document as Prose. */
  children: ReactNode;
  className?: string;
};

/** Legal, policy and info pages (privacy, terms, accessibility, bot): contents and plain reading, no primary action. */
export function DocumentTemplate({
  breadcrumbs,
  eyebrow,
  title,
  updated,
  entity,
  toc,
  children,
  className,
}: DocumentTemplateProps) {
  return (
    <PageContainer className={className}>
      <div className="py-jc-section">
        <SplitLayout aside={toc} asidePosition="left" asideWidth="toc" stickyAside>
          <article className="flex max-w-3xl flex-col gap-jc-block">
            <header className="flex flex-col gap-2">
              {breadcrumbs ? <div className="mb-2">{breadcrumbs}</div> : null}
              {eyebrow ? <span className="type-eyebrow text-jc-ink-secondary">{eyebrow}</span> : null}
              <h1 className="type-display text-jc-ink">{title}</h1>
              {updated || entity ? (
                <p className="text-sm text-jc-ink-secondary">
                  {updated}
                  {updated && entity ? ' · ' : null}
                  {entity}
                </p>
              ) : null}
            </header>
            {children}
          </article>
        </SplitLayout>
      </div>
    </PageContainer>
  );
}
